export const h5 = (theme: any) => ({
  h5: {
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(6),
    [theme.breakpoints.up("sm")]: {
      marginTop: theme.spacing(10),
    },
    fontSize: 22,
  },
});
